// extracted by mini-css-extract-plugin
export default {"tradersDiscount":"traders-discount_tradersDiscount__+vQ5y"};